import moment from 'moment/moment';
import { useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Spinner from '../../../utilities/Spinner';
import Post from './Post';

const Home = ({ setSelectedPage }) => {
  const [selectedType, setSelectedType] = useState('Scheduled');
  const selected = 'bg-darkblue text-white py-1 px-3 rounded-md cursor-pointer';
  /*useEffect(() => {
    localStorage.setItem('posts', JSON.stringify(posts));
  }, [posts]); */
  const { loading, posts } = useSelector((state) => state.post);

  const date_group = {};

  const status_group = { scheduled: [], published: [] };
  // let d = JSON.parse(localStorage.getItem('posts'));
  const formatDate = (date) => {
    return moment(date).format('DD MMM YYYY');
  };
  if (posts.length && loading === false) {
    posts.forEach((post) => {
      if (!date_group[formatDate(post.Createdat)]) {
        date_group[formatDate(post.Createdat)] = [post];
      } else {
        date_group[formatDate(post.Createdat)].push(post);
      }
      if (post.Status === 'Scheduled') {
        status_group.scheduled.push(post);
      } else if (post.Status === 'Live') {
        status_group.published.push(post);
      }
    });
  }
  // console.log(status_group);

  return (
    <div className="pb-5  bg-lightblue">
      <div className="bg-lightblue py-3 px-5 border grid grid-cols-2">
        <div className="flex items-center space-x-3">
          <p
            className={selectedType === 'Scheduled' && selected}
            onClick={() => setSelectedType('Scheduled')}
          >
            Queue
          </p>
          <p
            className={selectedType === 'Live' && selected}
            onClick={() => setSelectedType('Live')}
          >
            Published
          </p>
        </div>
        <div className="flex items-center space-x-3 justify-self-end">
          <p className="hidden md:block">
            Date
            <i className="fa-solid fa-calendar-days pl-2"></i>
          </p>
          <p>
            Filters <i className="fa-solid fa-filter"></i>
          </p>
        </div>
      </div>

      <section className="flex gap-10">
        {loading ? (
          <div className="flex justify-center items-center w-full h-screen ">
            <Spinner lg={true} />
          </div>
        ) : (
          <>
            <div className="h-auto md:flex flex-col items-center flex-[0.15] border bg-white space-y-5 hidden">
              {Object.keys(date_group).map((date) => (
                <div className="h-[178.3px] pt-2 flex flex-col items-center">
                  <p className="font-semibold">
                    {moment(date).format('ddd- DD MMM YYYY')}
                  </p>
                </div>
              ))}
            </div>
            <div className="space-y-5 flex-1 ">
              {Object.keys(date_group).map((el) => (
                <div className="flex gap-5 md:overflow-x-auto items-center md:max-w-screen-lg max-w-sm min-h-[174px]">
                  {date_group[el]
                    .filter((post) => post.Status === selectedType)
                    .map((post) => (
                      <Post data={post} />
                    ))}
                  <Add setSelectedPage={setSelectedPage} />
                </div>
              ))}
            </div>
          </>
        )}
      </section>
    </div>
  );
};

const Add = ({ setSelectedPage }) => {
  return (
    <div
      className="w-12 h-12 bg-white border-2 flex justify-center items-center cursor-pointer hover:bg-lightblue"
      onClick={() =>
        setSelectedPage({
          title: 'AddPost',
        })
      }
    >
      <i className="fa-solid fa-plus"></i>
    </div>
  );
};

export default Home;

/*
{data.scheduled.map((post) => (
                <div className="h-[178.3px] pt-2 flex flex-col items-center">
                
                  <p className="font-semibold">
                    {moment(post.Scheduledat).format('ddd- DD MMM YYYY')}
                  </p>
                  
                </div>
              ))}
*/
